// @flow
import type {
  CreateBrowserSession,
  GetBrowserSession,
} from '../core/browserSession';

import * as browserSession from './browserSession';

type Deps = {
  getBrowserSession: GetBrowserSession,
  createBrowserSession: CreateBrowserSession,
};

export default ({
  getBrowserSession,
  createBrowserSession,
}: Deps) => {

  return {
    browserSession: {
      getBrowserSessionId: browserSession.getSessionId(
        getBrowserSession,
        createBrowserSession,
      ),
    },
  };
};
